/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetLinkedViewsPathParams = NonNullable<operations['getLinkedViews']['parameters']['path']>;

export type GetLinkedViewsQueryParams = NonNullable<operations['getLinkedViews']['parameters']['query']>;

export interface Input extends GetLinkedViewsPathParams {
  apiVersion?: string;
  query?: GetLinkedViewsQueryParams;
  header: NonNullable<operations['getLinkedViews']['parameters']['header']>;
}

export async function getLinkedViews(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/view-associations/{resourceType}/{resourceKey}', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
